var mp = mp || {};

// Toogle Menu
//-----------------------------------------------------------------
mp.menuToggle = function () {
    var $toggleButton = $(".header__hamburger");
    var $drawerWraper = $(".header__navigation");

    if (!$toggleButton.length) {
        return;
    }

    $toggleButton.on("touchstart click", function (e) {
        e.preventDefault();

        $drawerWraper.toggleClass("is_open");
        $(this).toggleClass("is_open");
        $(".header").toggleClass("is_open");
        $("body").toggleClass("locked");
    });
};

// Showing/hiding header on scroll
//-----------------------------------------------------------------
mp.stickyHeader = function () {
    var $header = $(".header"),
        headerHeight = $header.outerHeight(),
        lastScrollTop = 0,
        offset = 0,
        didScroll;

    if (!$header.length) {
        return;
    }

    $(window).scroll(function (event) {
        didScroll = true;
    });

    var st = $(window).scrollTop();

    if (st > 0) {
        didScroll = true;
    }

    setInterval(function () {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    }, 250);

    function hasScrolled() {
        var st = $(this).scrollTop();

        if (Math.abs(lastScrollTop - st) <= offset) {
            return;
        } else {
            didScroll = true;
        }

        if (st > lastScrollTop && st > headerHeight) {
            // Scroll down
            $header.removeClass("nav_down").addClass("nav_up");
        } else if (st + $(window).height() < $(document).height()) {
            // Scroll up
            $header.removeClass("nav_up").addClass("nav_down");
        }

        if ($(window).scrollTop() <= 100) {
            $header.removeClass("nav_down nav_up");
        }

        lastScrollTop = st;
    }
};

// Mobile menu: open/close submenus on click/touch (below 1024px)
mp.submenuToggle = function () {
    var $items = $(".header__navigation .have-submenu");

    if (!$items.length) {
        return;
    }

    $items.children(".menu__link").attr("aria-expanded", "false");

    $items.children(".menu__link").on("click", function (e) {
        if (window.matchMedia("(min-width: 1024px)").matches) {
            return;
        }

        e.preventDefault();

        var $item = $(this).parent();
        var isOpen = !$item.hasClass("is_open");

        // Close other open submenus
        $item
            .siblings(".is_open")
            .removeClass("is_open")
            .children(".menu__link")
            .attr("aria-expanded", "false");

        $item.toggleClass("is_open", isOpen);
        $(this).attr("aria-expanded", isOpen ? "true" : "false");
    });
};

// Mobile search: icon only, field opens on click (below 820px)
mp.searchToggle = function () {
    var $search = $(".header__actions .search");

    if (!$search.length) {
        return;
    }

    var $input = $search.find(".form__input");
    var $submit = $search.find(".form__submit");

    function isMobile() {
        return window.matchMedia("(max-width: 819px)").matches;
    }

    function close() {
        $search.removeClass("is_open");
        $submit.attr("aria-expanded", "false");
    }

    $submit.attr({ "aria-label": "Pretraži", "aria-expanded": "false" });

    $submit.on("click", function (e) {
        if (!isMobile()) {
            return;
        }

        // Open on first click, submit only when there is a search term
        if (!$search.hasClass("is_open")) {
            e.preventDefault();
            $search.addClass("is_open");
            $submit.attr("aria-expanded", "true");
            $input.trigger("focus");
        } else if (!$.trim($input.val())) {
            e.preventDefault();
            close();
        }
    });

    $input.on("keydown", function (e) {
        if (e.key === "Escape") {
            close();
            $submit.trigger("focus");
        }
    });

    // Close on click outside or when the menu opens
    $(document).on("click touchstart", function (e) {
        if (
            $search.hasClass("is_open") &&
            !$(e.target).closest($search).length
        ) {
            close();
        }
    });
};

$(document).ready(function () {
    mp.menuToggle();
    mp.stickyHeader();
    mp.submenuToggle();
    mp.searchToggle();
});
